/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { Consts, I18nService, TimeService, UNPLACEHOLDER, UtilService } from '@dm/core';
import { type SelectOption } from '@dm/core/types';
import { ToolService } from 'app/common/services';

import { INVALID_NUM } from '../../../../../common/constants';
import {
BackupCopyPolicyType,
BandwidthRange,
    IntervalRangeMinute, IntervalRangeSecond, RemTimeoutPeriodRange, SyncSnapPolicyType } from './rep-pair-enum';

interface KV { [key: string]: string }

@Injectable({
    providedIn: 'root',
})
export class RepPairStrService {
    colon = this.i18n.get('common.colon_label');

    i18nLabel = {
        yesLabel: this.get('common.term_yes_label'),
        noLabel: this.get('common.term_No_label'),
        isStandbyLabel: this.get('protection.dataProtection_term_drStar_standby_lab'),
        owningDrStar: this.get('protection.dataProtection_term_drStar_ID_lab'),
        protectionTitle: this.get('common.protection_title'),

        autoRescoveryStrategyTips: this.get('protection.replicaiton_create_setProperty_option_rescoveryStrategy_auto_des_lab'),
        manuRescoveryStrategyTips: this.get('protection.replicaiton_create_setProperty_option_rescoveryStrategy_manual_des_lab'),
        syncMethodTips: this.get('protection.replication_create_task_para_SynchronizateType_SpecificTimePolicy_tip'),
        linkCompressionTips: this.get('protection.replication_task_create_info_linkCompression_tip'),
        enableSecondSourceTip: this.i18n.get('common.replicationPair_task_enableSecondSource_error_tips'),
        disableSecondSourceTip: this.i18n.get('common.replicationPair_task_disableSecondSource_error_tips'),
        autoInitalSyncTips: this.get('protection.replicaiton_create_task3_setProperty_option_initSync_Pair_value_inconsist_auto_message'),
        manuInitalTips: this.get('protection.replicaiton_create_task3_setProperty_option_initSync_Pair_value_inconsist_manual_message'),
        noInitalSyncAutoTips: this.get('protection.replicaiton_create_task3_setProperty_option_initSync_value_consist_message'),
        filterDataTip: this.get('common.filterNoMeetData_tip'),

        deviceModel: this.get('common.device_model_label'),

        pairListLab: this.get('storage.smartMigration_task_create_pairList_lab'),
        remoteDeviceName: this.get('common.remoteDevName_column'),
        syncRestTime: this.get('protection.hyperMetro_term_syncRestTime_column'),
        belongToRepCg: this.get('protection.replicaiton_view_ownReplicationCG_lab'),

        createPair: this.get('protection.replicaiton_task_create_Pair_title'),
        priLunLab: this.get('protection.replicaiton_term_primaryLUN_tab'),
        secLunLab: this.get('protection.replicaiton_term_slaveLUN_tab'),
        targetStoragePool: this.get('protection.replicaiton_task_create_remoteStoragePool_lab'),
        rmStoragePool: this.get('protection.replicaiton_task_create_remoteStoragePool_lab'),
        customSpeedUnit: this.get('common.unit_MBS'),
        replicationPair: this.get('protection.replicaiton_task_create_replicaitonPair_lab'),
        pairsErrMsg: this.get('protection.replicaiton_task_exsistLocal_notconfiguredPair_tip'),

        vstoreLabel: this.get('common.owningVstore_lab'),
        rmVstoreLabel: this.get('common.remoteVstore_lab'),
        vstoreName: this.get('vstore_name_lab'),
        vstoreId: this.get('vstore_id_lab'),

        localCapacity: this.get('common.localCap_column'),
        remoteCapcatiy: this.get('common.remoteCap_column'),
        remoteVstoreId: this.get('common.remoteVstoreID_column'),
        remoteVstoreName: this.get('common.remoteVstore_lab'),


        pairArrowRight: '➜',

        modifyRepPairTitle: this.get('protection.protectionGroup_modifyReplicationPair_tittle'),
        syncRepPairTitle: this.get('protection.dataProtection_term_createDRStar_synRemoteRepPair_tittle'),
        splitRepPairTitle: this.get('protection.replicaiton_task_split_Pair_title'),
        deleteRepPairTitle: this.get('protection.replicaiton_task_delete_Pair_title'),
        switchoverRepPairTitle: this.get('protection.replicationCG_switch_tittle'),


        generateConfirmPairName: this.get('protection.replicaiton_create_task_confirm_lab'),

        protectIntegrity: this.get('protection.replication_delete_task_info_protectLUNIntegrity_checkbox'),

        commaLable: this.get('common.comma_label'),

        selectedLuns: this.get('common.selectedLun_column', true),
        selectedLun: this.get('common.selected', [this.get('common.objectType_LUN')]),

        specifyObjectLab: this.get('protection.protectionGroup_task_addMember_specifyObject_lab'),
        configurePairLab: this.get('protection.protectionGroup_task_addMember_configPair_lab'),
        configureProtectLab: this.get('protection.hyperMetroCG_task_create_step1_configureProtection_lab'),
        confirmLab: this.get('common.confirm_lab'),
        excuteResultLab: this.get('common.executeResult_title'),
        avaiableLunLab: this.get('common.availableLun_column'),
        selectedLunLab: this.get('common.selectedLun_column'),
        selectOneObjectErr: this.get('common.selectOneObject_lab'),
        selectMaxObjectErr: this.get('common.selectedObjectNum_max_tip'),

        intervalRangeLabelMinute: this.get('common.valueRange_label', [IntervalRangeMinute.Min, IntervalRangeMinute.Max]),
        intervalRangeLabelSecond: this.get('common.valueRange_label', [IntervalRangeSecond.Min, IntervalRangeSecond.Max]),
        bandwidthRangeLabel: this.get('common.valueRange_label', [BandwidthRange.Min, BandwidthRange.Max]),
        remTimeoutPeriodRangeLabel: this.get('common.valueRange_label', [RemTimeoutPeriodRange.Min, RemTimeoutPeriodRange.Max]),

        createBtn: this.get('common.create_button'),
        deleteBtn: this.get('common.delete_button'),
        closeBtn: this.get('common.close_button'),
        addBtn: this.get('common.add_button'),
        okBtn: this.get('common.confirm_button'),
        cancelBtn: this.get('common.cancel_button'),
        removeBtn: this.get('common.remove_button'),
        modifyBtn: this.get('common.modify_button'),
        actionBtn: this.get('common.operation_button'),
        advance: this.get('common.advance_label'),
        configureBtn: this.get('protection.replicationCG_task_create_remoteRepliPair_configure_lab'),
        addToPairListBtn: this.get('storage.smartMigration_term_addToPairList_button'),
        nextBtn: this.get('common.next_button'),
        previousBtn: this.get('common.previous_button'),

        name: this.get('common.name_column'),
        wwn: this.get('storage.lun_view_summary_localWWN_label'),
        description: this.get('common.description_column'),
        status: this.get('common.status_column'),
        sn: this.get('common.device_ESN_label'),
        pleaseSelect: this.get('common.select_lab'),

        replicationCG: this.get('protection.replicationCG_lab'),

        syncRemoteStatusBtn: this.get('protection.replication_term_syncRomoteStatus_button'),
        synchronize: this.get('protection.replicationCG_sync_button'),
        split: this.get('protection.replicationCG_split_button'),
        switchover: this.get('protection.replicationCG_switch_button'),
        enableSecondary: this.get('protection.replicationCG_term_enableSecondResourceProtect_button'),
        disableSecondary: this.get('protection.replicationCG_term_disableSecondResourceProtect_button'),
        healthStatus: this.get('common.healthStatus_column'),
        runningStatus: this.get('common.runningStatus_column'),
        protectionGroup: this.get('protection.protectionGroup_task_create_protectionGroup_lab'),
        targetGroup: this.get('protection.replicationCG_term_targetGroup_lab'),
        localPG: this.get('protection.replicationCG_term_localPG_lab'),
        remotePG: this.get('protection.replicationCG_term_remotePG_lab'),
        remoteDeviceSN: this.get('protection.replicationCG_term_remoteDeviceSN_column'),
        role: this.get('protection.hyperMetroCG_term_localSourceRole_column'),
        replicationModel: this.get('common.copyMode_label'),
        speed: this.get('common.speed_label'),
        speedTip: this.i18n.get('protection.replication_create_task_speed_tip'),
        synchronizationMethod: this.get('protection.replicationCG_term_syncMode_label'),
        interval: this.get('protection.replicationCG_term_timingPeriod_label'),
        recoveryPolicy: this.get('protection.replicationCG_term_rescoveryStrategy_lab'),
        linkCompression: this.get('protection.replicationCG_term_linkCompression_lab'),
        compressionStatus: this.get('protection.configuration_remoteDevice_task_modify_compressStatus_label'),
        syncStartTime: this.get('protection.replicationCG_term_syncStartTime_label'),
        syncEndTime: this.get('protection.replicationCG_term_syncEndTime_label'),
        localLunName: this.get('common.localLunName_column'),
        remoteLunName: this.get('common.remoteLunName_column'),
        localResource: this.get('common.localResource_column'),
        remoteResource: this.get('common.remoteResource_column'),
        priResDataStatus: this.get('protection.replicationCG_task_view_primaryLunDataStatus_column'),
        secResDataStatus: this.get('protection.replicationCG_task_view_secondaryLunDataStatus_column'),
        secResProtectStatus: this.get('protection.replicationCG_task_view_secondayResourceProtectionStauts_lab'),
        timeDiff: this.get('protection.replicationCG_task_view_timeDifference_lab'),

        createReplicationCG: this.get('protection.replicationCG_task_create_title'),
        Asynchronous: this.get('common.EnumDefine_RM_MODEL_E_RM_MODEL_ASYNC'),
        Synchronous: this.get('common.EnumDefine_RM_MODEL_E_RM_MODEL_SYNC'),
        replicationModelSyncTip: this.get('protection.replicaiton_task_create_Pair_syncMode_info'),
        localDevice: this.get('common.EnumDefine_PRIORITY_STATION_TYPE_E_LOCAL'),
        remoteDevice: this.get('common.remoteDevice_title'),
        pairCreationMode: this.get('protection.replicationCG_task_create_pairCreateMode_lab'),
        Automatic: this.get('common.EnumDefine_STARTUP_MODE_E_AUTO'),
        Manual: this.get('common.EnumDefine_STARTUP_MODE_E_MANUAL'),
        replicationPairs: this.get('common.RemoteReplicationPairs'),
        configure: this.get('protection.replicationCG_task_create_remoteRepliPair_configure_lab'),
        syncMethod: this.get('protection.replicationCG_term_syncMode_label'),
        dataTransmission: this.get('storage.lun_task_create_smartCompression_label'),
        initialSync: this.get('protection.replicationCG_task_create_initialSync_lab'),
        setTimeOutTitle: this.i18n.get('protection.replicaiton_task_view_remoteIOTimeout_lab'),
        setTimeOutLable: this.get('protection.replicationCG_task_create_remoteIOTimeout_lab'),
        setTimeOutTip: this.get('protection.replicationCG_task_create_remoteIOTimeout_desc'),
        timeoutInterval: this.get('protection.replicationCG_task_create_Timeout_lab'),
        inconsistent: this.get('protection.hyperMetroCG_task_create_initialSync_dataInConsistent_checkbox'),
        consistent: this.get('protection.hyperMetroCG_task_create_initialSync_dataConsistent_checkbox'),
        notSync: this.get('protection.hyperMetroCG_task_create_initialSync_dataConsistent_noSync_value'),

        customSpeed: this.get('protection.replicationCG_task_create_custom_speed_lab'),

        confiurePair: this.get('protection.protectionGroup_task_addMember_configPair_lab'),
        sourceLun: this.get('common.sourceLun_label'),
        targetLun: this.get('common.targetLun_label'),
        operation: this.get('common.operation_button'),
        capacity: this.get('common.capacity_column'),
        addToPairList: this.get('protection.replicationCG_task_configPair_addPairList_button'),
        deleteOption: this.get('protection.replicationCG_task_delete_confirm_onlyDelOwningDevice_checkbox'),

        syncRepPair: this.get('rest.syncReplicationPair_msg'),
        splitRepPair: this.get('rest.splitReplicationPair_msg'),
        deleteRepPair: this.get('rest.deleteReplicationPair_msg'),

        min: this.get('common.time_minutes_label'),
        sec: this.get('common.time_seconds_label'),
        loading: this.get('common.loading_label'),
        more: this.get('common.more_button'),
        noData: this.get('monitor.recentTasks_result_noData'),
        // 按时间策略
        timeStrategy: this.i18n.get('common.EnumDefine_RM_UPDATE_TYPE_E_RM_UPDATE_TYPE_SEPCIFY_TIMING'),
        sun: this.i18n.get('common.seven_checkbox'),
        mon: this.i18n.get('common.one_checkbox'),
        tues: this.i18n.get('common.two_checkbox'),
        wed: this.i18n.get('common.three_checkbox'),
        thrs: this.i18n.get('common.four_checkbox'),
        fri: this.i18n.get('common.five_checkbox'),
        sat: this.i18n.get('common.six_checkbox'),
        specifyTimeErr: this.i18n.get('protection.HyperCDPSchedule_task_create_step2_weeklyExecute_tip'),
        time: this.i18n.get('common.time_label'),
        weekLabel: this.i18n.get('common.week_label'),
        // 时间策略
        timeStrategys: this.i18n.get('protection.replication_task_configPair_timePolicy_lab'),
        week: this.i18n.get('protection.replication_task_configPair_week_lab'),
        hour: this.i18n.get('protection.replication_task_configPair_Hourly_lab'),
        day: this.i18n.get('protection.replication_task_configPair_Daily_lab'),
        minute: this.i18n.get('protection.replication_task_configPair_Minute_lab'),
        rangeResult: (value1: string, value2: string): string => this.get('common.valueRange_label', [value1, value2]),
        // '每周{0}{1}执行'
        repPairWeekDescLab: this.get('protection.replication_task_configPair_weekDesc_lab'),
        // '每小时的第{0}分钟执行'
        repPairHourlyDescLab: this.get('protection.replication_task_configPair_HourlyDesc_lab'),
        // '每天{0}执行'
        repPairDailyDescLab: this.get('protection.replication_task_configPair_DailyDesc_lab'),

        initialAutoSyncDes: this.get('protection.hyperMetroCG_task_create_initialSync_autosync_checkbox'),
        initialManuSyncDes: this.get('protection.hyperMetroCG_task_create_initialSync_manualsync_checkbox'),
        initialNotSyncDes: this.get('protection.hyperMetroCG_task_create_initialSync_notSync_checkbox'),

        commonLimitLabel: (min: string, max: string): string => this.get('common.common_limit_label', [min, max]),
        bandwidthLabel: this.get('common.bandwidth_label'),
        bandwidthLabelLeft: this.get('common.bandwidth_label') + ' > ',
        bandwidthLabelRight: this.get('common.bandwidth_label') + ' < ',
        durationLabel: this.get('protection.replicaiton_task_modify_duration_lab'),
        unconfiguredLab: this.get('common.unconfigured_lab'),
        rangeValidation: (label: string, min: string, max: string): string => this.get('common.range_validation', [label, min, max]),
        performanceTermDelayLab: this.get('home.performance_term_delay_lab'),
        performanceTermDelayLabLeft: this.get('home.performance_term_delay_lab') + ' > ',
        performanceTermDelayLabRight: this.get('home.performance_term_delay_lab') + ' < ',
        whenLab: this.get('common.when_lab'),
        orLab: this.get('common.or_lab'),
        andLab: this.get('common.and_lab'),
        asyncSwitchBtn: this.get('protection.replicaiton_task_manualSyncAsyncSwitch_btn'),
        asyncRepLab: this.get('protection.replicaiton_task_modify_startAsyncRep_lab'),
        syncRepLab: this.get('protection.replicaiton_task_modify_startSyncRep_lab'),
        configAtLeastOneErrorInfoLab: this.get('protection.replicaiton_task_modify_configAtLeastOne_error_info_lab'),
        bandwidthLargerErrorInfoLab: this.get('protection.replicaiton_task_modify_bandwidth_asyncLarger_error_info_lab'),
        performanceTermDelayLargerErrorInfoLab: this.get('protection.replicaiton_task_modify_latency_asyncLarger_error_info_lab'),
        durationErrorInfoLab: this.get('protection.replicaiton_task_modify_duration_error_info_lab'),
        // detail
        asyncRepCondition1Lab: (bandwitdh: string): string =>
            this.get('protection.replicaiton_task_view_startAsyncRep_condition1_lab', [bandwitdh]),
        asyncRepCondition2Lab: (latency: number): string => this.get('protection.replicaiton_task_view_startAsyncRep_condition2_lab', [latency]),
        asyncRepCondition3Lab: (bandwitdh: string, latency: number): string => this.get('protection.replicaiton_task_view_startAsyncRep_condition3_lab',
            [bandwitdh, latency]),

        syncRepCondition1Lab: (bandwitdh: string, transferCycle: number): string => this.get('protection.replicaiton_task_view_startSyncRep_condition1_lab',
            [bandwitdh, transferCycle]),
        syncRepCondition2Lab: (latency: number, transferCycle: number): string => this.get('protection.replicaiton_task_view_startSyncRep_condition2_lab',
            [latency, transferCycle]),
        // eslint-disable-next-line max-len
        syncRepCondition3Lab: (bandwitdh: string, latency: number, transferCycle: number): string => this.get('protection.replicaiton_task_view_startSyncRep_condition3_lab',
            [bandwitdh, latency, transferCycle]),
        syncRepCondition4Lab: (bandwitdh: string): string => this.get('protection.replicaiton_task_view_startSyncRep_condition4_lab',
            [bandwitdh]),
        syncRepCondition5Lab: (latency: number): string => this.get('protection.replicaiton_task_view_startSyncRep_condition5_lab',
        [latency]),
        syncRepCondition6Lab: (bandwitdh: string, latency: number): string => this.get('protection.replicaiton_task_view_startSyncRep_condition6_lab',
            [bandwitdh, latency]),
        // card
        cardAsyncRep_condition1Lab: (bandwitdh: string): string => this.get('protection.replicaiton_task_view_startAsyncRep_condition1_info',
            [bandwitdh]),
        cardAsyncRep_condition2Lab: (latency: number): string => this.get('protection.replicaiton_task_view_startAsyncRep_condition2_info',
            [latency]),
        cardAsyncRep_condition3Lab: (bandwitdh: string, latency: number): string =>
            this.get('protection.replicaiton_task_view_startAsyncRep_condition3_info', [bandwitdh, latency]),
        cardSyncRep_condition1Lab: (bandwitdh: string, transferCycle: number): string =>
            this.get('protection.replicaiton_task_view_startSyncRep_condition1_info', [bandwitdh, transferCycle]),
        cardSyncRep_condition2Lab: (latency: number, transferCycle: number): string =>
            this.get('protection.replicaiton_task_view_startSyncRep_condition2_info', [latency, transferCycle]),
        cardSyncRep_condition3Lab: (bandwitdh: string, latency: number, transferCycle: number): string =>
            this.get('protection.replicaiton_task_view_startSyncRep_condition3_info', [bandwitdh, latency, transferCycle]),
        cardSyncRep_condition4Lab: (bandwitdh: string): string =>
            this.get('protection.replicaiton_task_view_startSyncRep_condition4_info', [bandwitdh]),
        cardSyncRep_condition5Lab: (latency: number): string =>
            this.get('protection.replicaiton_task_view_startSyncRep_condition5_info', [latency]),
        cardSyncRep_condition6Lab: (bandwitdh: string, latency: number): string => this.get('protection.replicaiton_task_view_startSyncRep_condition6_info',
            [bandwitdh, latency]),
        asyncSwitchErrorTip: this.get('protection.replicaiton_task_modify_manualSyncAsyncSwitch_error_tip'),
        timeAcountMinutesLabel: this.get('common.timeAcount_minutes_label'),
        msLabel: this.get('common.ms_label'),
        advancedLab: this.get('common.advance_label'),
        disableValue: this.get('common.service_disable_value'),
        switchLab: this.get('protection.replicaiton_task_modify_enableAutoSyncAsyncSwitch_error_tip'),
        startAsyncRepLab: this.get('protection.replicaiton_task_modify_startAsyncRep_error_tip'),
        valueRangeLabel: (min: string, max: string): string => this.get('common.valueRange_label', [min, max]),
        switchRepModePairMsg: this.i18n.get('rest.switchRepModePair_msg'),
        manualStartAsyncRepLab: this.i18n.get('protection.replicaiton_task_modify_manualStartAsyncRep_lab'),
        syncSnapPolicyLab: this.i18n.get('protection.replicaiton_task_createAsync_userSnapSync_lab'),
        userSnapRetentionNumLab: this.i18n.get('protection.replicaiton_task_createAsync_secondUserSnapRetenNum_lab'),
        backupCopyPolicyLab: this.i18n.get('protection.replicaiton_task_createAsync_secondSnapCopyReten_lab'),
        copySnapRetentionNumLab: this.i18n.get('protection.replicaiton_task_createAsync_secondSnapCopyRetenNum_lab'),
        syncSnapPolicyTip: this.i18n.get('protection.replicaiton_task_createAsync_userSnapSync_pair_tip'),
        backupCopyPolicyTip: this.i18n.get('protection.replicaiton_task_createAsync_secondSnapCopyReten_pair_tip'),
        remoteDeviceIsCompatibiltyErr: this.i18n.get('protection.protection_task_v3_supportAsync_info'),
        supportManualInfo: this.i18n.get('protection.protection_task_v3_supportManual_info'),
        supportManualOnlyInfo: this.i18n.get('protection.protection_task_v3_supportManualOnly_info'),
        compatibleErr: this.i18n.get('protection.protection_task_v3_notSupport_info'),

        sameAsLocalValue: this.i18n.get('protection.replication_term_sameAsLocal_value'),
        customValue: this.i18n.get('common.custom_value'),
        prefixMsg: this.i18n.get('protection.replication_term_prefix_validation'),
        suffixMsg: this.i18n.get('protection.replication_term_suffix_validation'),
        prefixTip: this.get('protection.replication_term_prefix_tip'),
        suffixTip: this.get('protection.replication_term_suffix_tip'),
        selectOneAtLeastMsg: this.i18n.get('protection.replication_term_selectOneAtLeast_validation'),
        localLUNnameLabel: this.i18n.get('protection.replication_term_localLUNname_label'),

        // 远端资源名称
        remoteResourceName: this.i18n.get('protection.replication_term_remoteResourceName_label'),
        remoteNameTip: this.get('protection.replication_term_remoteResourceName_tip', [255, 255]),
        // 本端资源名称
        localResourceName: this.i18n.get('protection.replication_term_localResourceName_label'),
        // 远端LUN组和远端保护组均采用该命名规则
        remotePGName: this.i18n.get('protection.replication_term_remotePGName_label'),
        // 自定义（{0}
        customShowInfo1: (namePrefix: string): string => this.i18n.get('protection.replication_term_customShow_info1', [namePrefix]),
        // *本端资源名称*
        customShowInfo2: this.i18n.get('protection.replication_term_customShow_info2'),
        // {1}）
        customShowInfo3: (nameSuffix: string): string => this.i18n.get('protection.replication_term_customShow_info3', [nameSuffix]),
        commonNameErr: this.i18n.get('common.nameformat_validation', [this.i18n.get('common.name_column')]),
        remoteResourceNameSame: this.i18n.get('protection.replication_term_remoteResourceNameSame_info_msg'),
        closeButton: this.i18n.get('common.close_button'),
        nowSyncData: this.i18n.get('protection.replicaiton_task_view_toBeSyncDataNow_lab'),
        nextSyncData: this.i18n.get('protection.replicaiton_task_view_toBeSyncDataNext_lab'),
    };
    // 带宽范围
    bandwidthMin = '1 KB/s';
    bandwidthMax = '10 GB/s';
    bandwidthNumMin = 1;
    bandwidthNumMax = 10 * 1024 * 1024;
    // 时延范围
    performanceTermDelayMin = '1 ms';
    performanceTermDelayMax = '5000 ms';
    // 持续范围
    durationMin = 1;
    durationMax = 1440;
    // 带宽默认单位
    DEFAULT_A_UNIT = 'KB/s';
    // 健康状态
    healthstatusE = {
        invalid: '14',
    };
    // 运行状态
    runningStatusE = {
        invalid: '35',
        standby: '110',
    };

    statusClass = {
        1: 'green',
        2: 'red',
        14: 'gray',
    };

    healthStatusObj = this.getI18n({
        1: 'common.EnumDefine_STATUS_E_NORMAL',
        2: 'common.EnumDefine_HEALTH_STATUS_fault',
    });

    deviceRunningStatusObj = this.getI18n({
        10: 'common.EnumDefine_RUNNING_STATUS_E_LINK_UP',
        11: 'common.EnumDefine_RUNNING_STATUS_E_LINK_DOWN',
        31: 'common.EnumDefine_RUNNING_STATUS_E_DISABLED',
        101: 'common.EnumDefine_RUNNING_STATUS_E_CONNECTING',
    });

    runningStatusObj = this.getI18n({
        1: 'common.EnumDefine_STATUS_E_NORMAL',
        23: 'common.EnumDefine_RUNNING_STATUS_E_SYNCHRONIZING',
        26: 'protection.replicationCG_split_button',
        33: 'common.EnumDefine_RUNNING_STATUS_E_TO_BE_RECOVERD',
        34: 'common.EnumDefine_RUNNING_STATUS_E_INTERRUPTED',
        35: 'common.EnumDefine_CMO_LICENSE_STATUS_4',
        110: 'common.EnumDefine_RUNNING_STATUS_E_STANDBY',
        118: 'common.EnumDefine_RUNNING_STATUS_E_AIRGAPDISCONNECT',
    });

    replicationModeObj = this.getI18n({
        1: 'common.EnumDefine_RM_MODEL_E_RM_MODEL_SYNC',
        2: 'common.EnumDefine_RM_MODEL_E_RM_MODEL_ASYNC',
    });

    syncMethodObj = this.getI18n({
        1: 'common.EnumDefine_STARTUP_MODE_E_MANUAL',
        2: 'common.EnumDefine_RM_UPDATE_TYPE_E_RM_UPDATE_TYPE_AUTO_START_TIMING',
        3: 'common.EnumDefine_RM_UPDATE_TYPE_E_RM_UPDATE_TYPE_AUTO_END_TIMING',
        4: 'common.EnumDefine_RM_UPDATE_TYPE_E_RM_UPDATE_TYPE_SEPCIFY_TIMING',
    });

    roleObj = this.getI18n({
        true: 'common.EnumDefine_ROLE_MASTER',
        false: 'common.EnumDefine_ROLE_SLAVER',
    });

    speedObj = this.getI18n({
        1: 'common.EnumDefine_SPEED_LEVEL_E_SPEED_LEVEL_LOW',
        2: 'common.EnumDefine_SPEED_LEVEL_E_SPEED_LEVEL_MIDDLE',
        3: 'common.EnumDefine_SPEED_LEVEL_E_SPEED_LEVEL_HIGH',
        4: 'common.EnumDefine_SPEED_LEVEL_E_SPEED_LEVEL_ASAP',
        custom: 'common.custom_value',
    });

    recoverPolicyObj = this.getI18n({
        1: 'common.EnumDefine_STARTUP_MODE_E_AUTO',
        2: 'common.EnumDefine_STARTUP_MODE_E_MANUAL',
    });

    dataTransmisionObj = this.getI18n({
        true: 'common.EnumDefine_REPLICATION_DATA_COMPRESSION_Y',
        false: 'common.EnumDefine_REPLICATION_DATA_COMPRESSION_N',
    });

    compressionStatusObj = this.getI18n({
        true: 'common.EnumDefine_CERTIFICATE_STATUS_VALID',
        false: 'common.EnumDefine_CERTIFICATE_STATUS_INVALID',
    });

    initalSyncObj = this.getI18n({
        1: 'common.EnumDefine_STARTUP_MODE_E_AUTO',
        2: 'common.EnumDefine_STARTUP_MODE_E_MANUAL',
    });

    intervalUnitObj = this.getI18n({
        min: 'common.time_minutes_label',
        sec: 'common.time_seconds_label',
    });

    priResDataStatusObj = this.getI18n({
        1: 'common.EnumDefine_RUNNING_STATUS_E_SYNCHRONIZED',
        2: 'common.EnumDefine_HC_DATA_STATE_HC_DATA_INTEGRITY',
        5: 'common.EnumDefine_HC_DATA_STATE_HC_DATA_INCOMPLETENESS',
    });

    secResDataStatusObj = this.getI18n({
        1: 'common.EnumDefine_RUNNING_STATUS_E_SYNCHRONIZED',
        2: 'common.EnumDefine_HC_DATA_STATE_HC_DATA_INTEGRITY',
        5: 'common.EnumDefine_HC_DATA_STATE_HC_DATA_INCOMPLETENESS',
    });

    secResProtectStatusObj = this.getI18n({
        1: 'protection.replicationCG_view_secondaryLunDataStatus_NoAccess_lab',
        2: 'settings.userAndRole_term_readonly_list',
        3: 'settings.userAndRole_term_readWrite_list',
    });


    bandWidthUnitObj = this.getI18n({
        0: 'KB/s',
        1: 'MB/s',
        2: 'GB/s',
    });

    /**
     * 用户快照同步策略
     */
    syncSnapPolicyOptions: SelectOption[] = [
        {
            label: this.i18n.get('protection.replicaiton_task_createAsync_userSnapSync_no_value'),
            value: SyncSnapPolicyType.NOT_SYNC_SNAP,
        },
        {
            label: this.i18n.get('protection.replicaiton_task_createAsync_userSnapSync_sameAsSource_value'),
            value: SyncSnapPolicyType.SAME_AS_SOURCE,
        },
        {
            label: this.i18n.get('protection.replicaiton_task_createAsync_userSnapSync_retentionNum_value'),
            value: SyncSnapPolicyType.USER_SNAP_RETENTION_NUM,
        },
    ];

    /**
     * 从端副本快照保留策略
     */
    backupCopyPolicyOptions: SelectOption[] = [
        {
            label: this.i18n.get('protection.replicaiton_task_createAsync_secondSnapCopyReten_no_value'),
            value: BackupCopyPolicyType.NO_RETENTION,
        },
        {
            label: this.i18n.get('protection.replicaiton_task_createAsync_secondSnapCopyReten_retentionNum_value'),
            value: BackupCopyPolicyType.COPY_SNAP_RETENTION_NUM,
        },
    ];

    dateOpt: SelectOption[] = [
        {
            label: this.i18nLabel.sun,
            value: 0,
        }, {
            label: this.i18nLabel.mon,
            value: 1,
        }, {
            label: this.i18nLabel.tues,
            value: 2,
        }, {
            label: this.i18nLabel.wed,
            value: 3,
        }, {
            label: this.i18nLabel.thrs,
            value: 4,
        }, {
            label: this.i18nLabel.fri,
            value: 5,
        }, {
            label: this.i18nLabel.sat,
            value: 6,
        },
    ];


    priResDataStatusOptions = this.obj2Options(this.priResDataStatusObj);
    healthStatusOptions = this.obj2Options(this.healthStatusObj);
    runningStatusOptions = this.obj2Options(this.runningStatusObj);
    replicationModeOptions = this.obj2Options(this.replicationModeObj);
    syncMethodOptions = this.obj2Options(this.syncMethodObj);
    roleOptions = this.obj2Options(this.roleObj);
    speedOptions = this.obj2Options(this.speedObj);
    recoverPolicyOptions = this.obj2Options(this.recoverPolicyObj);
    dataTransmisionOptions = this.obj2Options(this.dataTransmisionObj);
    initalSyncOption = this.obj2Options(this.initalSyncObj);
    intervalUnitOptions = this.obj2Options(this.intervalUnitObj);
    secResDataStatusOptions = this.obj2Options(this.secResDataStatusObj);
    bandWidthUnitOptions = this.obj2Options(this.bandWidthUnitObj);

    promptTips = this.getI18n({
        create: 'protection.replicaiton_create_task_confirmation_message',
        highestSpeedOverwriteCreate: 'protection.replication_create_task_replicationPairwithHighest_info',
        highestSpeedCreate: 'protection.replication_batchCreate_task_replicationPairwithHighest_info',
        speedGreaterThanOrEqualTo100mCreate: 'protection.replication_task_create_speedGreater_confirm_msg',
        highestSpeedModify: 'protection.replication_Change_Highest_info',
        speedGreaterThanOrEqualTo100mModify: 'protection.replication_task_modify_toCustomSpeed_confirm_msg',
        sync: 'protection.replication_manageReplication_task_syncData_confirmation_message',
        syncBatch: 'protection.replication_task_batchSync_confirm_msg',
        switch: 'protection.replication_manageReplication_task_switch_confirmation_message',
        split: 'protection.replication_manageReplication_task_split_confirmation_message',
        splitBatch: 'protection.replication_batchSplit_task_confirmation_message',
        delete: 'protection.replication_delete_task_confirmation_message',
        deleteBatch: 'protection.replication_batchdelete_task_confirmation_message',
    });

    constructor(
        private i18n: I18nService,
        private util: UtilService,
        private time: TimeService,
        public toolService: ToolService,
    ) { }

    poolFreeCapacity(value: string | number): string {
        return this.i18n.get('storage.lun_task_create_availableCapacity_lab', [
            this.util.adaptUnit(value || 0, Consts.SECTOR).label,
        ]);
    }

    nullErrMsg(name: string): string {
        const i18nName = this.i18nLabel[name];
        return this.i18n.get('common.null_validation', [i18nName]);
    }

    /**
     * 长度范围错误
     * @param min
     * @param max
     */
    rangeByteLengthErr(min: number, max: number): string {
        return this.i18n.get('common.length_msg', [min, max]);
    }

    /**
     * 名称格式错误
     * @param name
     */
    commonNameErr(name: string): string {
        const i18nName = this.i18nLabel[name];
        return this.i18n.get('common.nameformat_validation', [i18nName]);
    }

    nameErrMsg(name: string | number): string {
        const i18nName = this.i18nLabel[name];
        return this.i18n.get('common.nameformat_validation', [i18nName]);
    }

    lengthErrMsg(min: number, max: number): string {
        return this.i18n.get('common.length_msg', [min, max]);
    }

    startErrMsg(name: string | number): string {
        const i18nName = this.i18nLabel[name];
        return this.i18n.get('common.name_tip', [i18nName]);
    }

    obj2Options(obj: KV): {
        value: string;
        label: any;
    }[] {
        return Object.keys(obj).map((key) => {
            const option = {
                value: key,
                label: obj[key],
            };
            return option;
        });
    }

    // 转换UTC时间戳为带时区信息的字符串
    renderTime = (time: number): string => time === 0 ?
        UNPLACEHOLDER :
        this.time.formatOffsetUTC(time * 1e3);


    formatSeconds(oriValue: string): string {
        const value = Number(oriValue);
        if (value === -1 || isNaN(value) || value === INVALID_NUM) {
            return UNPLACEHOLDER;
        }

        const sec = (value % 60).toString().padStart(2, '0');
        const min = (Math.floor(value / 60) % 60).toString().padStart(2, '0');
        const hour = (Math.floor(value / 3600)).toString().padStart(2, '0');

        return `${hour}:${min}:${sec}`;
    }

    get(key: string, params?: any[] | boolean, colon?: boolean): string {
        return this.i18n.get(key, params, colon);
    }

    getPairName(isPrimary: boolean, localName: string, remoteName: string): string {
        return isPrimary ? `${localName} ${this.i18nLabel.pairArrowRight} ${remoteName}` :
            `${remoteName} ${this.i18nLabel.pairArrowRight} ${localName}`;
    }

    parseInt10(num: string): number {
        return parseInt(num, 10);
    }

    getProgressValue(val: string): number {
        const num = Number(val);
        return (!isNaN(num) && num <= 100 && num >= 0) ? num : 0;
    }

    getProductModel = (model: string): string => {
        if (!model) {
            return '';
        }

        return this.toolService.getProductModelName(Number(model));
    };

    /**
     * 范围错误
     * @param min
     * @param max
     */
    rangeErr(name: string, min: string, max: string): string {
        return this.i18n.get('common.range_validation', [name, min, max]);
    }

    /**
     * 更新速率tip的速率上限
     */
     updateSpeedTipUpLimit(bandwidthUpLimit: number): string {
        return this.i18n.get('protection.replication_create_task_speed_common_tip', [bandwidthUpLimit]);
    }

    /**
     * 更新自定义速率范围的速率上限
     */
    updateRangeLabelUpLimit(bandwidthUpLimit: number): string {
        return this.i18n.get('common.valueRange_label', [BandwidthRange.Min, bandwidthUpLimit]);
    }

    /**
     * @description 带宽，时延，持续 详情页面的展示
     * @param {bandwitdh}  带宽
     * @param {latency} 时延
     * @param {transferCycle} 持续
     */
    getDetailString = (from: 'detail' | 'card',
        type: 'async' | 'sync',
        bandwitdh?: string,
        latency?: number,
        transferCycle?: number): string => {
        let value = 0;
        let bandwitdhObj: { value: number; unit: string; label: string };
        let str;
        if (bandwitdh) {
            bandwitdhObj = this.randerBandWidth(bandwitdh);
            value += 1;
        }
        if (latency) {
            value += 2;
        }
        if (transferCycle) {
            value += 4;
        }
        const map = new Map([
            [0, (): void => {
                str = UNPLACEHOLDER;
            }],
            [1, (): void => {
                if (from === 'detail') {
                    str = type === 'async' ? this.i18nLabel.asyncRepCondition1Lab(bandwitdhObj.label) :
                        this.i18nLabel.syncRepCondition4Lab(bandwitdhObj.label);
                } else {
                    str = type === 'async' ? this.i18nLabel.cardAsyncRep_condition1Lab(bandwitdhObj.label) :
                        this.i18nLabel.cardSyncRep_condition4Lab(bandwitdhObj.label);
                }
            }],
            [2, (): void => {
                if (from === 'detail') {
                    str = type === 'async' ? this.i18nLabel.asyncRepCondition2Lab(latency) :
                        this.i18nLabel.syncRepCondition5Lab(latency);
                } else {
                    str = type === 'async' ? this.i18nLabel.cardAsyncRep_condition2Lab(latency) :
                        this.i18nLabel.cardSyncRep_condition5Lab(latency);
                }
            }],
            [3, (): void => {
                if (from === 'detail') {
                    str = type === 'async' ?
                        this.i18nLabel.asyncRepCondition3Lab(bandwitdhObj.label, latency) :
                        this.i18nLabel.syncRepCondition6Lab(bandwitdhObj.label, latency);
                } else {
                    str = type === 'async' ?
                        this.i18nLabel.cardAsyncRep_condition3Lab(bandwitdhObj.label, latency) :
                        this.i18nLabel.cardSyncRep_condition6Lab(bandwitdhObj.label, latency);
                }
            }],
            [5, (): void => {
                if (from === 'detail') {
                    str = this.i18nLabel.syncRepCondition1Lab(bandwitdhObj.label, transferCycle);
                } else {
                    str = this.i18nLabel.cardSyncRep_condition1Lab(bandwitdhObj.label, transferCycle);
                }
            }],
            [6, (): void => {
                if (from === 'detail') {
                    str = this.i18nLabel.syncRepCondition2Lab(latency, transferCycle);
                } else {
                    str = this.i18nLabel.cardSyncRep_condition2Lab(latency, transferCycle);
                }
            }],
            [7, (): void => {
                if (from === 'detail') {
                    str = this.i18nLabel.syncRepCondition3Lab(bandwitdhObj.label, latency, transferCycle);
                } else {
                    str = this.i18nLabel.cardSyncRep_condition3Lab(bandwitdhObj.label, latency, transferCycle);
                }
            }],
        ]);
        map.get(value)();
        return str;
    };

    /**
     * 渲染带宽数据
     * @param bandWidth 接口返回的带宽值（KB为单位）
     */
    randerBandWidth(bandWidth: string): { value: number; unit: string; label: string } {
        let value;
        let unit;
        if (!bandWidth) {
            return { value, unit, label: UNPLACEHOLDER };
        }

        const k = Number(bandWidth);
        const m = k / 1024;
        const g = m / 1024;

        if (g === Math.floor(g)) {
            value = g;
            unit = 2;
        } else if (m === Math.floor(m)) {
            value = m;
            unit = 1;
        } else {
            value = k;
            unit = 0;
        }

        return {
            value,
            unit,
            label:  value ? value + ' ' + this.bandWidthUnitOptions[unit].label : UNPLACEHOLDER,
        };
    }

    private getI18n(kv: KV): KV {
        const keys = Object.keys(kv);
        const result = {};
        keys.forEach((key) => {
            result[key] = this.get(kv[key]);
        });
        return result;
    }
}
